import React, { useEffect, useRef, useState } from 'react'
import AntDraggableModal from '../../../utils/extend/AntDraggableModal'
import { Button, Card, Checkbox, Col, Divider, Form, Input, InputNumber, List, Row, Select } from 'antd';
import systemConfig from '../../../config/systematic';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../universal/getList';
import antMessage from '../../../utils/extend/AntdNotification'
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import FaPiao from './FaPiao';
import arrayHandle from '../../../utils/baseLib/arrayHandle';


/**结账页面 */
export default function SetAccounts(props: any) {
    const { data, closeModal } = props;
    const [form] = Form.useForm(); //form 

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;
    const [faPiaoOpen, setFaPiaoOpen] = useState<boolean>(false);
    const [order, setOrder] = useState<any>({});

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedMembershipCard, setSelectedMembershipCard] = useState<any>(null);
    const formListData = Form.useWatch("paymentMethodList", form) as any;

    const payModeId = Form.useWatch("payModeId", form) as any;

    const [isFaPiao, setIsFaPiao] = useState<boolean>(false)
    const notificationApi = useNotificationInstance()

    const inputRef = useRef<any>(null);

    const [membershipData, setMembershipData] = useState<Array<any>>([]);

    /** 分店支付方式 */
    const [paymentListData, setPaymentListData] = useState<Array<any>>([]);

    const [faPiaoData, setFaPiaoData] = useState<any>();

    /**支付模式 */
    const [payMode, setPayMode] = useState<Array<any>>();


    /** 处理会员卡勾选变化 */
    const handleMembershipCardSelect = (card: any) => {
        if (selectedMembershipCard && selectedMembershipCard.id === card.id) {
            // 如果点击已选中的卡片，则取消选择
            setSelectedMembershipCard(null);
        } else {
            // 否则选择新卡片
            setSelectedMembershipCard(card);
        }
    };
    //关闭发票选择页面
    const onClosefaPiao = async (status: boolean) => {
        // setFaPiaoOpen(false)
        closeModal(true)

    }
    const handleOk = (e: any, isFaPiao?: boolean) => {
        setIsLoading(true)
        form.validateFields() //数据校验
            .then(async (values: any) => {
                if (payModeId === 1) {
                    const findData = await arrayHandle.findValue(paymentListData, "id", values.paymentListId)
                    if (findData) {
                        if (findData?.data.paymentType === 2) {
                            if (values.money !== findData?.data.deductionAmount) {
                                showCustomNotification(notificationApi!, {
                                    type: 'error',
                                    message: "当前方式是代金券，无法完全支付，请使用混合支付",
                                  
                                });
                                setIsLoading(false)
                                return false
                            }
                        }
                    }
                }
                fetchApi.POST(wmService, {
                    apiId: "cateringOrder",
                    apiExtend: "settleAccounts",
                    apiData: {
                        orderId: data.id,
                        tempRoomId: data.tempRoomId,
                        ...values,
                        membershipCardId: selectedMembershipCard?.id
                        // money:0.01,
                        // menuSpe:selectMenuSpeData
                    }
                }).then(res => {

                    setIsLoading(false)
                    showCustomNotification(notificationApi!, {
                        type: 'success',
                        message: "结账成功!",
                        description: "success"
                    });
                    if (isFaPiao) {
                        //  closeModal(false);
                        setFaPiaoData({ orderId: data.id, branchStoreId: res.data.branchStoreId });
                        setFaPiaoOpen(true)
                    } else {
                        closeModal(true);

                    }
                    // antMessage('success', '新增成功', 'success');
                }).catch(err => {
                    setIsLoading(false)

                    showCustomNotification(notificationApi!, {
                        type: 'error',
                        message: "错误，无法保存",
                        description: err.message + ' | status：' + err.errors.status,
                    });
                })
            })
            .catch((err: any) => {
                setIsLoading(false)
                const { errorFields } = err;
                let errors = errorFields[0].errors[0]
                showCustomNotification(notificationApi!, {
                    type: 'warning',
                    message: "无法通过数据校验",
                    description: errors
                });
                // antMessage('warning', '无法通过数据校验', errors);
            });
    }
    const handleCancel = (e: any) => {
        closeModal(false)

    }

    //初始化数据
    const initData = () => {

        fetchApi.GET(wmService, {
            apiId: "cateringOrder",
            apiExtend: "getSettleAccounts",
            apiData: {
                id: data.id
            }
        }).then((res) => {
            setIsFaPiao(res.data.isFaPiao)

            form.setFieldsValue({
                ...res.data,
                payModeId: 1,
                money: Number(res.data.shouldMoney) - Number(res.data.realMoney)
            })

            setOrder(res.data)
        }).catch((err) => {
            console.log("err", err);
            closeModal(false)
            showCustomNotification(notificationApi!, {
                type: 'error',
                message: "错误",
                description: err.message
            });
            // antMessage("error", '错误', err.message);
        })
    }
    useEffect(() => {
        const fetchData = async () => {
            fetchApi.GET(wmService,
                {
                    apiId: 'paymentList',
                    apiExtend: 'showList',
                    apiData: {
                        mountDataOptions: {
                            userMount: {
                                isDept: true,
                            }
                        },
                    }
                }).then(res => {
                    if (res.success) {
                        form.setFieldValue("paymentMethodList", res.data)
                        setPaymentListData(res.data)
                        form.setFieldValue("paymentListId", res.data[0].id)
                    } else {
                        antMessage("error", '无支付信息', '错误');

                    }
                });
            fetchApi.GET(wmService, {
                apiId: "generalData",
                apiExtend: 'showList',
                apiVariable: "payMode",
            }).then(res => {
                if (res.success) {

                    setPayMode(res.data)
                }
            })
        }

        fetchData()
        initData()

        setTimeout(() => {
            if (inputRef.current) {
                inputRef.current?.focus()!;
            }
        }, 100)
    }, [])





    const changePayMode = (e: any) => {
        if (e === 1) {
            if (paymentListData.length > 0) {
                form.setFieldValue("paymentListId", paymentListData[0].id)
            }

        }

    }
    /**会员卡登录 */
    const membershipCardLogin = () => {
        let membershipCardId = form.getFieldValue("membershipCardId");

        fetchApi.GET(wmService, {
            apiId: "membership",
            apiExtend: "getInfo",
            "apiVariable": membershipCardId,
            apiData: {
                applicablesShopId: order.branchStoreId
            }
        }).then((res) => {

            if (res.success) {
                setMembershipData(res.data)
                if (res.data.length === 0) {
                    antMessage("warning", '查询不到该会员，请检查会员id/手机号码/当店不允许该会员卡使用');
                } else {
                    if (res.data.length === 1) {
                        setSelectedMembershipCard(res.data[0])
                    }
                    antMessage("success", '登录成功');
                }




            } else {
                antMessage("error", '登录失败', JSON.stringify(res.message));
            }

        }).catch((err) => {
            antMessage("error", '登录失败', JSON.stringify(err));
        })

    }
    /**会员卡退出登录 */
    const membershipCardExitLogin = () => {
        setMembershipData([])
        setSelectedMembershipCard(null)
        antMessage("success", '退出成功');
    }
    const payDetailCon = (data: any, name: any) => {
        // console.log("data", data);
        if (data) {
            switch (data.paymentType) {
                case 1:
                case 5:
                case 6:
                    return <InputNumber min={0.1} controls={false} addonBefore={<div>金额:</div>}></InputNumber>
                case 2:
                    return <InputNumber min={0.1} style={{ width: "50%" }} readOnly addonBefore={<div>金额:</div>} addonAfter={
                        <div style={{ width: 80, padding: '0 4px', borderLeft: '1px solid #d9d9d9' }}>
                            <InputNumber
                                onChange={(e) => numberCopies(e, name, data)}
                                min={0}
                                style={{ width: '100%' }}
                                addonBefore="张"
                            />
                        </div>
                    } ></InputNumber>
                case 4:
                    return <div style={{ justifyContent: "space-between", display: "flex", fontSize: 16 }}><InputNumber min={0.1} style={{ width: "50%" }} addonBefore={<div>金额:</div>}></InputNumber></div>
                default:
                    return <></>
            }
        }

    }
    const numberCopies = (e: any, name: any, data: any) => {
        let price = data.deductionAmount * e;
        form.setFieldValue(["paymentMethodList", name, "money"], price)
    }

    return (
        <>
            <AntDraggableModal
                title={"详情"}
                open={true}
                // okText='确定'
                // cancelText='取消'
                // onOk={handleOk}
                // onCancel={handleCancel}
                footer={[
                    <Button key="back" onClick={handleCancel}>
                        取消
                    </Button>,
                    <Button key="submit" type="primary" loading={isLoading} onClick={handleOk}>
                        确认
                    </Button>,
                    <Button style={{ display: isFaPiao ? "inline-block" : "none" }} type="primary" loading={isLoading} onClick={(e) => handleOk(e, true)}>
                        确认并开发票
                    </Button>,
                ]}
                closable={false}
                maskClosable={false}
                width={"80%"}
                confirmLoading={isLoading}

            >
                {/* <Row> */}
                {/* <Col span={24}> */}
                <div >
                    <Form
                        form={form}
                        name="Edit"
                        onFinish={handleOk}
                        onKeyDown={(e: any) => {
                            if (e.key === 'Enter') {
                                handleOk(e)
                            }
                        }}>
                        <Row>
                            <Col span={12}>
                                <Col span={24}>
                                    <Form.Item
                                        label="消费总额"

                                        name="totalMoney">
                                        <InputNumber ref={inputRef} autoFocus precision={2} readOnly addonAfter={"元"} ></InputNumber>
                                    </Form.Item>
                                </Col>



                                <Col span={24}>
                                    <Form.Item
                                        label="折扣额"
                                        name="agioMoney">
                                        <InputNumber precision={2} addonAfter={"元"} readOnly ></InputNumber>
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="服务费率"
                                        name="serviceRate"

                                    >
                                        <InputNumber readOnly ></InputNumber>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label="服务费"
                                        name="serviceCharge">
                                        <InputNumber precision={2} readOnly addonAfter={"元"} ></InputNumber>
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="应收金额"
                                        name="shouldMoney">
                                        <InputNumber precision={2} readOnly addonAfter={"元"} ></InputNumber>
                                    </Form.Item>
                                </Col>

                                <Col span={24}>
                                    <Form.Item
                                        label="已收金额"
                                        name="realMoney">
                                        <InputNumber precision={2} readOnly addonAfter={"元"} ></InputNumber>
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label="支付模式"
                                        name="payModeId"
                                        rules={[{ message: '请选择支付模式!', required: true }]}>
                                        <Select
                                            showSearch
                                            placeholder="支付模式"
                                            optionFilterProp="children"
                                            onChange={changePayMode}
                                            filterOption={(input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                            {getList.general(payMode)}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                {
                                    payModeId === 2 ? <Col span={24}>

                                        <Form.List name="paymentMethodList"
                                            rules={[
                                                {
                                                    validator: async (_, names) => {
                                                        if (names.length === 0) return Promise.reject(new Error("无支付信息"));
                                                        let isMoney = false;
                                                        let dataEx = form.getFieldsValue()
                                                        const { shouldMoney, realMoney } = dataEx;
                                                        let lastPrice = shouldMoney - realMoney;
                                                        let shouldMoneyEx = 0;

                                                        if (names.length > 0) {
                                                            for (let i = 0; i < names.length; i++) {
                                                                let money = names[i].money;
                                                                if (money) {
                                                                    isMoney = true;
                                                                    shouldMoneyEx += money;
                                                                }

                                                            }
                                                        }
                                                        if (isMoney === false) {
                                                            return Promise.reject(new Error("无支付信息"));
                                                        }
                                                        if (shouldMoneyEx !== lastPrice) return Promise.reject(new Error("支付金额应等于应收金额"));
                                                    },
                                                },
                                            ]}
                                        >
                                            {(fields, { add, remove }) => {
                                                return (
                                                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', width: "100%" }}>
                                                        {fields.map(({ key, name, ...restField }) => (

                                                            <Col className="gutter-row" span={24}>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label={formListData ? formListData[name].paymentMethodName : ""}
                                                                    name={[name, 'money']}
                                                                >
                                                                    {formListData ? payDetailCon(formListData[name], name) : null}
                                                                    {/* <InputNumber min={0} onChange={(value: any) => onChangeMoney(name, value)} addonAfter={"元"}></InputNumber> */}

                                                                </Form.Item>
                                                            </Col>






                                                        ))}
                                                        {/* <Col span={24}>
                                                            <Form.Item>
                                                                <Button type="dashed">
                                                                    自定义支付方式
                                                                </Button>
                                                            </Form.Item>
                                                        </Col> */}

                                                    </div>
                                                )
                                            }
                                            }
                                        </Form.List>



                                    </Col> : null

                                }
                                {
                                    payModeId === 1 ? <Col span={24}>

                                        <Col span={24}>
                                            <Form.Item
                                                label="支付方式"

                                                name="paymentListId"
                                                rules={[{ message: '请选择支付方式!', required: true }]}>
                                                <Select
                                                    showSearch
                                                    placeholder="支付方式"
                                                    optionFilterProp="children"
                                                    filterOption={(input, option: any) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                                    {getList.general(paymentListData, "paymentMethodName")}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={"支付金额"}
                                                name={'money'}
                                                rules={[
                                                    {
                                                        validator: async (_, names) => {
                                                            let dataEx = form.getFieldsValue()
                                                            const { shouldMoney, realMoney } = dataEx
                                                            let lastPrice = shouldMoney - realMoney;
                                                            if (names !== lastPrice) return Promise.reject(new Error("支付金额应等于应收金额"));
                                                        },

                                                    },
                                                ]}
                                            >

                                                <InputNumber readOnly min={0} addonAfter={"元"}></InputNumber>

                                            </Form.Item>
                                        </Col>

                                    </Col> : null

                                }




                                <Col style={{ display: "none" }} span={24}>
                                    <Form.Item
                                        label="先后付"
                                        name="orderPaymentModeId">
                                        <Input  ></Input>
                                    </Form.Item>
                                </Col>

                            </Col>

                            <Col span={12}>
                                <Col span={24}>
                                    <Form.Item
                                        label="会员登录"
                                        tooltip={"使用会员卡id登录/手机号登录"}

                                        name="membershipCardId">
                                        <Input placeholder='使用会员卡id登录/手机号登录' readOnly={membershipData?.length > 0 ? true : false} addonAfter={membershipData?.length > 0 ? <div onClick={membershipCardExitLogin}>退出登录</div> : <div onClick={membershipCardLogin}>登录</div>} ></Input>
                                    </Form.Item>
                                </Col>
                                <List
                                    itemLayout="horizontal"
                                    grid={{ gutter: 16, column: 2 }}
                                    dataSource={membershipData}
                                    // position
                                    renderItem={(menu: any) => {

                                        // title={`${menu?.membershipInfo.membershipName} ${menu.membershipType.typeName}`} 
                                        return (
                                            <List.Item>
                                                <Card
                                                    title={
                                                        <>
                                                            <div style={{ justifyContent: "space-between", display: "flex", fontSize: 15 }}>
                                                                <div>{menu?.membershipInfo.membershipName}</div>
                                                                <div>{menu.membershipType.typeName}</div>
                                                            </div>
                                                        </>
                                                    }
                                                    extra={<Checkbox checked={selectedMembershipCard?.id === menu.id}
                                                        onChange={() => handleMembershipCardSelect(menu)}>勾选</Checkbox>}>
                                                    <div style={{ justifyContent: "space-between", display: "flex", fontSize: "18px" }}>
                                                        <div>会员ID:{menu.id}</div>
                                                    </div>
                                                    <div style={{ justifyContent: "space-between", display: "flex", fontSize: "18px" }}>
                                                        <div >{`余额:${menu.balance}`}</div>
                                                        <div>{`赠送余额:${menu.gifts}`}</div>
                                                        <div>{`积分:${menu.points}`}</div>
                                                    </div>


                                                </Card>
                                            </List.Item>
                                        )
                                    }}
                                />

                            </Col>


                        </Row>
                    </Form>



                </div>
                {/* </Col> */}
                {/* </Row> */}

            </AntDraggableModal>
            {/**发票页面 */}
            {faPiaoOpen ? (<FaPiao data={faPiaoData} closeModal={onClosefaPiao} />) : null}
        </>
    )
}
